function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FootprintValue = void 0;
var _react = _interopRequireWildcard(require("react"));
var _Heading = require("../Heading");
var _View = require("../View");
var _reactNative = require("react-native-web");
var _styles = require("./styles");
var _utils = require("../../utils");
var _MassValue = require("../MassValue");
var _Button = require("../Button");
var _useLang = require("./useLang");
var _reactI18next = require("react-i18next");
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
    t = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
    return e ? t : r;
  })(e);
}
function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != _typeof(e) && "function" != typeof e) return {
    "default": e
  };
  var t = _getRequireWildcardCache(r);
  if (t && t.has(e)) return t.get(e);
  var n = {
      __proto__: null
    },
    a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
    var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
    i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
  }
  return n["default"] = e, t && t.set(e, n), n;
}
var FootprintValue = exports.FootprintValue = function FootprintValue(_ref) {
  var kgCo2eEmissions = _ref.kgCo2eEmissions,
    style = _ref.style;
  (0, _useLang.useLang)();
  var _useTranslation = (0, _reactI18next.useTranslation)(),
    t = _useTranslation.t;
  var _useStyles = (0, _styles.useStyles)(),
    styles = _useStyles.styles;
  var _useContext = (0, _react.useContext)(_utils.LinkContext),
    footprintPageLinkUrl = _useContext.footprintPageLinkUrl;
  if (!kgCo2eEmissions) return null;
  return (0, _jsxRuntime.jsxs)(_View.View, {
    style: style,
    testID: "FootprintValue",
    children: [(0, _jsxRuntime.jsx)(_Heading.Heading, {
      level: 2,
      style: styles.heading,
      children: t('footprintValue:title')
    }), (0, _jsxRuntime.jsx)(_MassValue.MassValue, {
      value: Math.trunc(kgCo2eEmissions),
      valueStyle: styles.footprintValue,
      unitStyle: styles.footprintUnit
    }), (0, _jsxRuntime.jsx)(_reactNative.Text, {
      style: styles.footprintSuffix,
      children: t('footprintValue:suffix')
    }), (0, _jsxRuntime.jsx)(_Button.Button, {
      type: _Button.ButtonType.brand,
      href: footprintPageLinkUrl,
      label: t('footprintValue:cta'),
      containerStyle: styles.cta
    })]
  });
};